import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {Terrace} from "@/modules/stadium/entity";
import {BeforeEntranceFeeChangeEvent} from "@/modules/stadium/events/BeforeEntranceFeeChangeEvent";
import {AfterEntranceFeeChangeEvent} from "@/modules/stadium/events/AfterEntranceFeeChangeEvent";

@injectable()
export default class EntranceFeeChanger {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
  ) {
  }

  public async set(terrace: Terrace, newFee: number) {
    if (!terrace.available) {
      throw 'There is not expansion planed for this terrace.';
    }

    await this.em.emitAsync(new BeforeEntranceFeeChangeEvent(terrace, terrace.entranceFee, newFee));

    terrace.entranceFee = newFee;
    await terrace.save();

    await this.em.emitAsync(new AfterEntranceFeeChangeEvent(terrace));
  }
}
